<template>
	<div class="box-filter" v-if="context">
		<div class="box-filter__options">
			<div
				v-for="option in fieldOptions"
				:key="option.value"
				@click="onOptionClick(option.value)"
				:class="`button button--option ${selected.indexOf(option.value) > -1 ? 'button--active' : ''}`"
			>
				<span
					v-if="showColors && optionColor(option)"
					class="dataSet-spanColor"
				>
					<span class="dataSet-spanColor--color" :style="{ backgroundColor: optionColor(option) }"></span>{{ option.label }}
				</span>
				<span
					v-else-if="showColors"
					:class="`dataSet-color dataSet-color--${colorClass(option)}`"
				>{{ option.label }}</span>
				<div v-else-if="showIcons" class="box-filter__option-wrapper">
					<img class="box-filter__option-image" :src="`/images/icons/${showIcons[option.machineName]}`" />
					<span class="box-filter__image-label">{{ option.label }}</span>
				</div>
				<span v-else>{{ option.label || option.machineName }}</span>
			</div>
		</div>
	</div>
</template>

<script src="./FormulateBoxSelect.js"></script>
